/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_IndustryInputs */

const et_contact_label_industry = /** @type {(inputs: Contact_Label_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valdkond`)
};

const en_contact_label_industry = /** @type {(inputs: Contact_Label_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry`)
};

/**
* | output |
* | --- |
* | "Industry" |
*
* @param {Contact_Label_IndustryInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_label_industry = /** @type {((inputs?: Contact_Label_IndustryInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_IndustryInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_label_industry(inputs)
	return en_contact_label_industry(inputs)
});